import { useQuery } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'

const useUserGoals = ({
    userId,
    onReload = () => {}
}) => {
    const cacheKeys = useCacheKeys()
    const { api, endpoints, url, time } = useApi()
    
    const {
        data,
        isLoading
    } = useQuery(
        [cacheKeys.USER_GOALS, userId],
        () => api.get(url(endpoints.userGoals, { userId })),
        {
            enabled: Boolean(userId),
            staleTime: time.HOUR
        }
    )

    return {
        isBusy: isLoading,
        userGoals: data ? data.items : [],
    }
}

export default useUserGoals